import {
  FixedFeeRevenueRecognitionTypes,
  SubscriptionRevenueRecognitionTypes,
} from 'api/settings-financials/types';
import type { FieldOption } from 'api/tasks';

export type AdvancedSetting =
  | {
      eventType: Exclude<
        SettingType,
        | SettingType.StopScheduledNotifications
        | SettingType.RevenueRecognitionAtProjectLevel
      >;
      eventValue: boolean;
      projectWithStatusesNotification?: FieldOption<number>['value'][] | null;
      allowedRevenueRecognitionTypes?: Record<
        FixedFeeRevenueRecognitionTypes | SubscriptionRevenueRecognitionTypes,
        boolean
      >;
    }
  | {
      eventType: SettingType.StopScheduledNotifications;
      eventValue: boolean;
      projectWithStatusesNotification: FieldOption<number>['value'][] | null;
      allowedRevenueRecognitionTypes?: Record<
        FixedFeeRevenueRecognitionTypes | SubscriptionRevenueRecognitionTypes,
        boolean
      >;
    }
  | {
      eventType: SettingType.RevenueRecognitionAtProjectLevel;
      eventValue: boolean;
      projectWithStatusesNotification?: FieldOption<number>['value'][] | null;
      allowedRevenueRecognitionTypes: Record<
        FixedFeeRevenueRecognitionTypes | SubscriptionRevenueRecognitionTypes,
        boolean
      >;
    };

export enum SettingsGroup {
  TaskStatusAutomation = 'TaskStatusAutomation',
  PhaseAutomation = 'PhaseAutomation',
  ScheduledNotifications = 'ScheduledNotifications',
}

export enum SettingType {
  MarkTaskAsCompletedIfSubTaskIs = 'MARK_PARENT_TASK_TO_COMPLETED_IF_SUBTASK_IS_COMPLETED',
  MarkTaskAsInProgressIfSubTaskIs = 'MARK_PARENT_TASK_TO_IN_PROGRESS_IF_SUBTASK_CHANGES',
  MarkSubTasksAsCompletedIfTaskIs = 'MARK_SUBTASKS_COMPLETED_IF_PARENT_IS_COMPLETED',
  AlignPhaseDates = 'BOUND_PHASE_DATES_TO_TASKS_START_AND_DUE_DATE_BOUNDARIES',
  StopScheduledNotifications = 'STOP_SCHEDULE_NOTIFICATION_PROJECT_STATUSES',
  OtpAuthentication = 'CUSTOMER_AUTHENTICATION_OTP_ENABLED',
  RevenueRecognitionAtProjectLevel = 'ALLOW_USERS_TO_SET_REV_REC_CONFIG_AT_PROJECT_LEVEL',
}

export const SettingsByGroup = {
  [SettingsGroup.TaskStatusAutomation]: [
    SettingType.MarkSubTasksAsCompletedIfTaskIs,
    SettingType.MarkTaskAsCompletedIfSubTaskIs,
    SettingType.MarkTaskAsInProgressIfSubTaskIs,
  ],
  [SettingsGroup.PhaseAutomation]: [SettingType.AlignPhaseDates],
  [SettingsGroup.ScheduledNotifications]: [
    SettingType.StopScheduledNotifications,
  ],
};
